import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 今日必推榜入口组件
 * <component-mush-list :is-promoter=""></component-mush-list>
 * isPromoter: 是否是推广员 1.是  0.不是
 * tagId,
 * tagName,
 * ranking:排名
 */
import { toQueryString } from '@ykz/ykz-util/base';
export default {
  name: 'mush_list',
  data: function data() {
    return {};
  },
  props: ['isPromoter', 'tagId', 'tagName', 'ranking'],
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.mushList = this;
    console.log('ycf组件初始化：mushList');
  },
  methods: {
    //跳转到今日必推页
    goDailyPushList: function goDailyPushList() {
      location.href = '/front/promoter/dailyPushList?' + toQueryString({
        weChatId: 1,
        tagId: this.tagId,
        tagName: this.tagName,
        simData: getUrlParams('simData') || '' //模拟假数据的参数
      });
    }
  }
};